import RadarChart from "ds/components/Charts/RadarChart";
import Card from "ds/components/Card";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import IconEmphasized from "ds/components/IconEmphasized";
import Badge from "ds/components/Badge";
import { RadarDatum } from "ds/components/Charts/RadarChart/types";

import { LaunchPadTrackMission } from "./MissionCompletionCards";
import styles from "./styles.module.css";

type LaunchPadTrackSkillChartProps = {
  missions: LaunchPadTrackMission[];
  totalUsers: number;
  loading: boolean;
};

const toPercentage = (count: number, total: number) =>
  total > 0 ? Math.round((count / total) * 100) : 0;

const LaunchPadTrackSkillChart = ({
  missions,
  totalUsers,
  loading,
}: LaunchPadTrackSkillChartProps) => {
  const renderSkillTooltip = (datum: RadarDatum) => {
    const mission = missions.find((m) => m.id === datum.id);
    return (
      <Box direction="row" gap="medium" align="start">
        {mission && <IconEmphasized icon={mission.icon} color={mission.iconColor} />}
        <Box direction="column" gap="small">
          <Box direction="row" align="center" gap="small">
            <Typography className={styles.tooltipText} color="primary" variant="p-t7" tag="span">
              {datum.label}
            </Typography>
            <Badge variant="gray" text={`${datum.value}%`} type="weak" />
          </Box>
          {mission && (
            <>
              <Typography
                className={styles.tooltipText}
                variant="p-body3"
                tag="span"
                color="secondary"
              >
                Completed: {mission.completedCount} users
              </Typography>
              <Typography
                className={styles.tooltipText}
                variant="p-body3"
                tag="span"
                color="secondary"
              >
                Started: {mission.startedCount} users
              </Typography>
            </>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Card title="Skill chart" fullbleed fullWidth>
      <Box padding="x-large" direction="column">
        <Box>
          <RadarChart
            isLoading={loading}
            data={missions.map((m) => ({
              id: m.id,
              label: m.label,
              value: toPercentage(m.completedCount, totalUsers),
            }))}
            secondaryData={missions.map((m) => ({
              id: m.id,
              label: m.label,
              value: toPercentage(m.startedCount, totalUsers),
            }))}
            fillColor="var(--semantic-color-background-interactive-data-non-semantic-1-rest)"
            strokeColor="var(--semantic-color-background-interactive-data-non-semantic-1-rest)"
            secondaryFillColor="var(--semantic-color-background-interactive-data-non-semantic-1-inactive)"
            secondaryStrokeColor="var(--semantic-color-background-interactive-data-non-semantic-1-rest)"
            gridColor="var(--semantic-color-border-divider)"
            showAxisDots
            renderTooltip={renderSkillTooltip}
            tooltipReactToScroll
            tooltipPlacement="left"
          />
        </Box>
      </Box>
    </Card>
  );
};

export default LaunchPadTrackSkillChart;
